import DisplayComponent from './DisplayComponent';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

registerBlockType('ib-podcast/podcast-description', {
	title: __('Podcast Description', 'ib-podcast-description'),
	icon: 'analytics',
	category: 'layout',
	supports: {
		multiple: true,
	},
	edit: DisplayComponent,
	save: () => null,
});
